import { ClientError } from '@/errors';

export function isQuestionLimitExceededError(error: any) {
  if (error instanceof ClientError) {
    return error.type === 'WorkspaceQuestionLimitReached';
  }

  return false;
}
